import Hashids from 'hashids';
import BotLinkWithCopy from '../../components/BotLinkWithCopy';

function Episode(params) {
    const { episode } = params;
    const hasTg = episode.url.includes("t.me");

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 12px',
            backgroundColor: '#fff',
            border: '1px solid #f3f4f6',
            borderRadius: '6px',
            fontSize: '13px'
        }}>
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ color: '#374151' }}>{episode.name}</span>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {episode.url && (
                    <a
                        href={episode.url}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            textDecoration: 'none',
                            color: hasTg ? '#10b981' : '#ef4444',
                            fontSize: '11px',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}
                    >
                        {hasTg ? 'Telegram' : 'Link'}
                    </a>
                )}

                {episode.uhdFileUrl && (
                    <a
                        href={episode.uhdFileUrl}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            textDecoration: 'none',
                            color: '#8b5cf6',
                            fontSize: '11px',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}
                    >
                        UHD File
                    </a>
                )}

                {episode.uhdVideoUrl && (
                    <a
                        href={episode.uhdVideoUrl}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            textDecoration: 'none',
                            color: '#6366f1',
                            fontSize: '11px',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}
                    >
                        UHD Video
                    </a>
                )}

                <BotLinkWithCopy externalId={episode.externalId} />
            </div>
        </div>
    );
}

export default Episode;